module.exports = __webpack_public_path__ + "img/honor4.77e86250.png";